import { render, staticRenderFns } from "./PegawaiReviewer.vue?vue&type=template&id=d47e01f6&scoped=true&lang=html&"
import script from "./PegawaiReviewer.vue?vue&type=script&lang=js&"
export * from "./PegawaiReviewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47e01f6",
  null
  
)

export default component.exports